<template>
  <el-container id="adviceSon">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} ></p>
        <p style="color:#000000;line-height:0.3;margin-left:5px;font-weight: bold;">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main" style="overflow:auto">
      <el-main style="background: #F4F4F4;">
        <div style="background:#FFFFFF;padding:15px;border-radius:20px;">
          <div style="display:flex;width:100%;">
            <div>
              <p v-if="showD"
                 style="font-size:18px;margin-left:20px;font-weight:bold;height:20px;line-height:20px;margin-bottom:0;">
                反馈ID：{{ showD["id"] }}</p>
              <p v-if="showD"
                 style="font-size:15px;margin-top:6px;margin-left:20px;font-weight:bold;height:20px;line-height:20px;color: #82848a">
                {{ showD["times1"] }}</p>
            </div>
            <p
                style="background: #ebb563;margin-left:auto;margin-right:36px;margin-top:20px;padding-top:10px;height:36px;margin-bottom:0;width:100px;text-align:center;border-radius:20px;">
              {{ showD["state"] }}</p>
          </div>
          <div style="display:flex;margin-top:10px;padding-left:20px">
            <div style="width:45%">
              <div style="height:80px;background:#F9FAFB;padding-left:15px;padding-top:15px;border-radius:20px;">
                <p style="margin-top:6px;margin-bottom:0">用户信息:</p>
                <p style="margin-top:6px">{{ showD.name }}</p>
              </div>
              <div
                  style="height:80px;margin-top:10px;background:#F9FAFB;padding-left:15px;padding-top:15px;border-radius:20px;">
                <p style="margin-top:6px;margin-bottom:0">联系方式:</p>
                <p style="margin-top:6px">{{ showD.phoneNumber }}</p>
              </div>
              <div
                  style="height:80px;margin-top:10px;background:#F9FAFB;padding-left:15px;padding-top:15px;border-radius:20px;">
                <p style="margin-top:6px;margin-bottom:0">反馈类型:</p>
                <p style="margin-top:6px">{{ showD.feedType }}</p>
              </div>
            </div>
            <div style="width:53%;background:#F9FAFB;border-radius:20px;margin-left:20px;padding:20px">
              <p style="margin:0">反馈内容:</p>
              <p style="margin-top:6px;margin-bottom:6px;word-break:break-all;word-wrap:break-word;">
                {{ showD.description }}</p>
              <el-image v-if="showD.liImg" v-for="(d,item) in showD.liImg" :key="item" :preview-src-list="showD.liImg"
                        style="height:160px;width:120px;margin-left:5px" fit="fit" :src="d">
              </el-image>
            </div>
          </div>
        </div>
        <div style="background: #FFFFFF;margin-top:20px;padding:15px;border-radius:20px;">
          <p>添加回复</p>
          <textarea :disabled="noOperate" v-model="ediDetail" style="width:98%;height:10vh;"></textarea>
          <div style="display:flex;width:98%">
            <el-button v-if="!noOperate" style="margin-left:auto;margin-right:1px;height:40px" type="info"
                       @click="onBack"
                       icon="el-icon-close">取消
            </el-button>
            <el-button v-if="noOperate"
                       style="margin-right:1px;height:40px;margin-left:auto;" @click="onBack" type="info"
                       icon="el-icon-back">返回
            </el-button>
            <el-button v-if="!noOperate" type="primary" @click="onKeep()" icon="el-icon-s-promotion"
                       style="height: 40px">回复
            </el-button>
          </div>
        </div>
      </el-main>
      <el-footer style="background-color:#F4F4F4;margin-bottom:10px;padding:0"></el-footer>
    </el-container>
  </el-container>
</template>

<script>
import axios from 'axios';

export default {
  name:"adviceSon",
  data() {
    return {
      h_text:"意见反馈详情",
      noOperate:false,
      li_h_text:[
        {"text":"会所管理","colour":"#B7B7B7","pages":""},
        {"text":"意见反馈管理","colour":"#B7B7B7","pages":""}
      ],
      page:1,
      pageSize:10,
      total:0,
      showD:{},
      edi_auth:"",
      li_auth:[],
      authPage:1,
      authPageSize:10,
      authTotal:10,
      zhName:"",
      password:"",
      name:"", /*账号*/
      value3:"",
      imageUrl:"",
      imageUrl1:"",
      imageId:-1,
      imageId1:-1,
      url_upFile:"",
      ediTitle:"", /*活动名称*/
      ediDetail:"", /*活动详情*/
      ediApplyStart:"", /*报名开始时间*/
      ediApplyEnd:"", /*报名结束时间*/
      ediValidStart:"", /*活动开始时间*/
      ediValidEnd:"", /*活动结束时间*/
      ediMaxApplys:"", /*最大报名个数*/
      ImageUrl:[], /*活动宣传图片*/
      CoverFile:"", /*活动封面图片*/
      CoverFileId:"", /*活动封面图片id*/
      sort:"", /*排序*/
      stateId:1, /*1 -"未发布", 2 - 已发布, 3 -已取消 4-已过期*/
      id:"",
      isCtr:true,
      isTop:false, /*是否置顶*/
      isBm:false /*是否开启报名限制*/
    };
  },
  computed:{},
  methods:{ /*方法存放*/
    handleSelectMenu(path) { /*左侧导航栏事件*/
      console.log(path);
      this.$router.push({path:path}); /*路由跳转*/
    },
    onKeep() {
      if (!(this.ediDetail)) {
        this.$message.info('请先输入回复内容');
        return;
      }
      if (this.isCtr) {
        this.isCtr = false;
        this.addProcessFeedback();
        setTimeout(() => {
          this.isCtr = true;
        },600);
      } else {
        this.isCtr = true;
      }
    },
    beforeAvatarUpload(file) {
      console.log(file.type);
      const isJPG = file.type === 'image/png' || file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('只能上传png/jpg格式的图片');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }
      return true; // 如果校验通过，返回true继续上传流程
    },
    uploadFile(content) {
      let formData = new FormData();
      formData.append('file',content.file); // 假设你的后端需要名为'file'的字段接收文件
      formData.append('projectId',localStorage.getItem("projectId")); // 假设你的后端需要名为'file'的字段接收文件
      // 设置请求头
      const config = {
        headers:{
          'Content-Type':'multipart/form-data', // 注意这里不需要设置Content-Type，因为FormData会自动设置正确类型
          'token':localStorage.getItem("token")
        }
      };
      console.log(this.$urls.ip + this.$urls.uploadFile);
      // 使用axios或其他HTTP客户端发送请求
      axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
          .then(response => {
            console.log(response.data);
            this.imageId = response.data.data.id;
            this.imageUrl = this.$urls.ip + "/" + response.data.data.url;
          }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("上传失败");
        }
      });
    },
    handleAvatarSuccess1(response) {
      console.log(response);
      // this.imageUrl = URL.createObjectURL(response.data.data.url);
    },
    beforeAvatarUpload1(file) {
      console.log(file.type);
      const isJPG = file.type === 'image/png' || file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('只能上传png/jpg格式的图片');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }
      return true; // 如果校验通过，返回true继续上传流程
    },
    uploadFile1(content) {
      let formData = new FormData();
      formData.append('file',content.file); // 假设你的后端需要名为'file'的字段接收文件
      formData.append('projectId',localStorage.getItem("projectId")); // 假设你的后端需要名为'file'的字段接收文件
      // 设置请求头
      const config = {
        headers:{
          'Content-Type':'multipart/form-data', // 注意这里不需要设置Content-Type，因为FormData会自动设置正确类型
          'token':localStorage.getItem("token")
        }
      };
      console.log(this.$urls.ip + this.$urls.uploadFile);
      // 使用axios或其他HTTP客户端发送请求
      axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
          .then(response => {
            console.log(response.data);
            this.imageId1 = response.data.data.id;
            this.imageUrl1 = this.$urls.ip + "/" + response.data.data.url;
          }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("上传失败");
        }
      });
    },
    handleAvatarSuccess(response) {
      console.log(response);
      // this.imageUrl = URL.createObjectURL(response.data.data.url);
    },
    addProcessFeedback() {
      const params = {
        "id":this.showD.id,
        "answer":this.ediDetail,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.processFeedback,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("回复成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("回复失败");
        }
      });
    },
    changeNotice(stateId) {
      const params = {
        'id':this.id,
        'title':this.ediTitle,
        'detail':this.ediDetail,
        'stateId':stateId,
        'pubTime':parseInt("" + new Date().getTime() / 1000),
        'sysUserId':localStorage.getItem("userId"),
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.updateNotify,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改失败");
        }
      });
    },
    onBack() {
      if (this.isCtr) {
        this.isCtr = false;
        this.$router.go(-1);
        setTimeout(() => {
          this.isCtr = true;
        },1000);
      } else {
        this.$message.info('处理中，请勿频繁点击');
      }
    },
    timestampToTime(timestamp) {/*秒转时间*/
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1):(date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate():date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours():date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds());
      return Y + M + D + h + m + s;
    },
    queryFeedback(id) {
      const params = {
        'id':id,
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      if (this.ediTitle) {
        params["title"] = this.ediTitle; /*角色id*/
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.queryFeedback,params,headers).then(res => {
        console.log("queryFeedback：",res.data.data);
        this.d_advice = res.data.data;
        if (this.d_advice) {
          this.total = res.data.data.total;
          this.init_View();
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取意见反馈数据失败");
        }
      });
    },
    init_View() {
      let data = this.d_advice;
      let d = {
        id:data['id'],
        name:data['name'],
        phoneNumber:data['phoneNumber'],
        feedType:data['feedType'],
        description:data['description'], /*用户反馈*/
        answer:data['answer'], /*回复*/
        times1:this.timestampToTime(data['feedbackTime'] * 1000),
        stateId:data['stateId'],
        imageUrl:data['imageUrl'],
        ediDetail:"",
        liImg:[],
        state:""
      };
      if (data['phoneNumber']) {
        d["applyNumber"] = data['phoneNumber'];
      } else if (data['applyNumber']) {
        d["applyNumber"] = data['applyNumber'];
      } else {
        d['applyNumber'] = data["otherPhoneNumber"];
      }
      if (data['name']) {
        d['name'] = data["name"];
      } else if (data['userName']) {
        d['name'] = data["userName"];
      } else if (data['nickName']) {
        d['name'] = data["nickName"];
      }
      if (d.answer) {
        this.ediDetail = d.answer;
      }
      switch (d.feedType) {
        case 1:
          d.feedType = "功能建议";
          break;
        case 2:
          d.feedType = "投诉建议";
          break;
        case 3:
          d.feedType = "服务体验";
          break;
        default:
          d.feedType = "其他";
          break;
      }
      if (d.imageUrl) {
        for (let i = 0; i < d.imageUrl.length; i++) {
          if (d.imageUrl[i].url) {
            d.liImg.push(`${this.$urls.ip}/${d.imageUrl[i].url}`);
          }
        }
      }
      switch (data.stateId) {
        case 0:
          d.state = "待处理";
          break;
        case 1:
          d.state = "待处理"; /*已反馈*/
          break;
        case 2:
          d.state = "已回复";
          break;
      }
      this.showD = d;
    }
  },
  mounted() { /*页面加载时调用*/
    const value = this.$route.query.key;
    this.id = parseInt(this.$route.query.id);
    if (this.$route.query.operate === 'w') {
      this.noOperate = false;
      this.h_text = "意见反馈回复";
    } else {
      this.noOperate = true;
      this.h_text = "意见反馈查看";
    }
    this.queryFeedback(this.id);
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#adviceSon {
  height: 95vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/hs/adviceSon.vue